import { responseCommands } from "./Constants";

const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let osName = "Unknown";
  const timestampString = new Date().toLocaleString();
  const language = navigator.language;

  // Detect Browser
  if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Mozilla Firefox";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserName = "Google Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    browserName = "Apple Safari";
  } else if (userAgent.indexOf("MSIE") > -1 || !!document.documentMode) {
    browserName = "Internet Explorer";
  }

  // Detect Operating System
  if (userAgent.indexOf("Win") > -1) osName = "Windows";
  else if (userAgent.indexOf("Mac") > -1) osName = "MacOS";
  else if (userAgent.indexOf("Linux") > -1) osName = "Linux";
  else if (userAgent.indexOf("Android") > -1) osName = "Android";
  else if (/iPhone|iPad|iPod/.test(userAgent)) osName = "iOS";
  console.log(navigator);

  return {
    OS: osName,
    browser: browserName,
    timestamp: timestampString,
    language: language,
  };
};

const downloadVCard = () => {
  const url = `${process.env.PUBLIC_URL}/resources/VCard_Mihailo_Simic.jpg`;
  const link = document.createElement("a");
  link.href = url;
  link.download = "VCard_Mihailo_Simic.jpg";
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadCV = () => {
  const url = `${process.env.PUBLIC_URL}/resources/Mihailo_Simic_CV.pdf`;
  const link = document.createElement("a");
  link.href = url;
  link.download = "Mihailo_Simic_CV.pdf";
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const redirectToGithub = () => {
  const url = "http://github.com/goldengun1";
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const scheduleReboot = (timer) => {
  if (timer === 0) {
    window.location.reload();
  } else {
    setTimeout(() => {
      window.location.reload();
    }, timer * 1000);
  }
};

const hanndleCommandWithOptions = (term, commands) => {
  console.log(commands);

  switch (commands[0]) {
    case "career":
      if (commands[1] === "-l") {
        term.write(responseCommands["career_list"]);
      } else if (commands[1] === "-t") {
        term.write(responseCommands["career_tree"]);
      } else {
        term.write(
          `\r\nWrong option for command '${commands[0]}', try 'help' to see available commands`
        );
      }
      break;
    case "get":
      if (commands[1] === "--cv") {
        console.log("CV DOWNLOAD");
        term.write("\r\nDownloading CV...");
        downloadCV();
      } else if (commands[1] === "--github") {
        console.log("GOTO: GitHub profile");
        term.write("\r\nRedirecting to GitHub profile...");
        redirectToGithub();
      } else if (commands[1] === "--vcard") {
        console.log("VCARD DOWNLOAD");
        term.write("\r\nDownloading VCard...");
        downloadVCard();
      } else {
        term.write(
          `\r\nWrong option for command '${commands[0]}', try 'help' to see available commands`
        );
      }
      break;
    case "qr":
      if (commands[1] === "--linkedin") {
        term.write(responseCommands["qr_linkedin"]);
      } else if (commands[1] === "--email") {
        term.write(responseCommands["qr_email"]);
      } else if (commands[1] === "--paypal") {
        term.write(responseCommands["qr_paypal"]);
      } else {
        term.write(
          `\r\nWrong option for command '${commands[0]}', try 'help' to see available commands`
        );
      }
      break;
    case "reboot":
      if (commands[1] === "--now") {
        scheduleReboot(0);
        return;
      } else if (commands[1] === "--time") {
        const timer = parseInt(commands[2], 10);
        if (isNaN(timer) || timer <= 0) {
          term.write(`\r\nTime must be a number greater than 0`);
          return;
        }
        term.write(`\r\nSystem reboot scheduled in ${timer} seconds...`);
        scheduleReboot(timer);
      } else {
        term.write(
          `\r\nWrong option for command '${commands[0]}', try 'help' to see available commands`
        );
      }
      break;
    default:
      term.write(
        `\r\nCommand "${commands[0]}" does not have options, try without options or type \x1b[32m'help'\x1b[m`
      );
  }
};

export const handleCommand = (
  term,
  setHistory,
  historyRef,
  setTerminalOpen
) => {
  const cursorLine = term.buffer.active.baseY + term.buffer.active.cursorY;
  const command = term.buffer.active
    .getLine(cursorLine)
    ?.translateToString()
    .split("$")[1]
    .toLowerCase()
    ?.trim();

  console.log(`LOWERCASED CMD: ${command}`);

  setHistory((prev) => {
    if (command === "") {
      return prev;
    } else {
      return [command, ...prev];
    }
  });
  if (command.split(" ").length !== 1) {
    console.log("COMMAND WITH OPTIONS");
    hanndleCommandWithOptions(term, command.split(" "));
    return;
  } else {
    console.log("NO OPTIONS COMMAND");
  }

  switch (command) {
    case "whoami":
      term.write(responseCommands["whoami"]);
      break;
    case "career":
      term.write(
        `\r\nUsage: career [OPTION]\r\n\t-l: \tlist-like path\r\n\t-t: \ttree view`
      );
      break;
    case "qr":
      term.write(
        `\r\nUsage: qr [OPTION]\r\n\t--linkedin: \tLikedIn profile\r\n\t--email: \tFor sending me an email\r\n\t--paypal: \tPaypal code`
      );
      break;
    case "clear":
      term.clear();
      break;
    case "exit":
      setTerminalOpen(false);
      break;
    case "about":
      // TODO: make about section
      break;
    case "pwd":
      term.write(`\r\n/home/guest`);
      break;
    case "reboot":
      term.write(
        `\r\nUsage: reboot [OPTION]\r\n\t--time <number>: \tSchedule reboot in <number> seconds\r\n\t--now: \t\t\tReboot immediately`
      );
      break;
    case "shutdown":
      window.location.replace("https://google.com");
      break;
    case "ls":
      // TODO: implement list directory action
      break;
    case "contact":
      term.write(responseCommands["contact"]);
      break;
    case "":
      term.write("\r");
      break;
    case "help":
      term.write(responseCommands["help"]);
      break;
    case "info":
      // term.write(responseCommands["info"]);
      const info = getBrowserInfo();
      term.writeln(`\r\n© Mihailo Simic - 2024 - All rights reserved`);
      term.write(
        "\r\nThis is my personal webpage app, aimed to be a computer like experience."
      );
      term.write(
        "\r\n\r\nHere, you can interact with a terminal by typing commands to learn\r\nmore about me, my career, and how to get in touch."
      );
      term.write(
        "\r\nThis fun and engaging design is crafted to make navigation easier and intuitive.\r\nDive in and explore!"
      );

      term.write(`\r\n\r\nYOUR INFO HERE:\r\n`);
      term.write(`\r\n\tClient Browser: ${info.browser}`);
      term.write(`\r\n\tClient OS: ${info.OS}`);
      term.write(`\r\n\tCurrent Timestamp: ${info.timestamp}`);
      term.write(`\r\n\tBrowser Language: ${info.language}`);
      break;
    case "history":
      for (let i = historyRef.current.length - 2; i >= 0; i--) {
        term.write(
          `\r\n${historyRef.current.length - (i + 1)}\t${historyRef.current[i]}`
        );
      }
      break;
    case "get":
      term.write(
        `\r\nUsage: get [OPTION]\r\n\t--cv: \t\tDownload my CV\r\n\t--github: \tGo to my GitHub profile\r\n\t--vcard: \tDownload my Vcard`
      );
      break;
    default:
      term.write(
        `\r\nCommand "${
          command.split(" ")[0]
        }" not found. \r\nTry \x1b[32m'help' \x1b[0mfor listing commands`
      );
    // term.clear();
  }
};

export const welcomeMessage = (term) => {
  responseCommands["ANSI_ART"].forEach((element) => {
    term.write(element);
  });
  term.writeln("");
};

export const handleBackspace = (term) => {
  const cursorLine = term.buffer.active.baseY + term.buffer.active.cursorY;
  const command = term.buffer.active
    .getLine(cursorLine)
    ?.translateToString()
    .split("$")[1]
    ?.trim();

  const cursorXPos = term.buffer.active.cursorX;
  if (cursorXPos <= 22) {
    return;
  } else {
    const rest = command.slice(cursorXPos - 22);
    term.write(`\b${rest} ${"\b".repeat(rest.length + 1)}`);
  }
};

export const handleLeftArrow = (term, key) => {
  if (term.buffer.active.cursorX <= 22) {
    return;
  } else {
    term.write(key);
  }
};

export const handleRightArrow = (term, key) => {
  const cursorLine = term.buffer.active.baseY + term.buffer.active.cursorY;
  const lineLength = term.buffer.active
    .getLine(cursorLine)
    ?.translateToString()
    .trim();
  if (term.buffer.active.cursorX >= lineLength.length) {
    return;
  } else {
    term.write(key);
  }
};
